module.exports = __webpack_public_path__ + "media/images/pic/hero/product-32a8baacc6fd9be0016784c17b737eef.webp";